import { gql } from "@apollo/client";

const GET_CLIENT_RELATIONSHIP = gql`
  query getClientRelationship(
    $clientIdentifier: String!
    $recipientClientIdentifier: String!
  ) {
    clientRelationship(
      clientIdentifier: $clientIdentifier
      recipientClientIdentifier: $recipientClientIdentifier
    ) {
      paidInvoiceCount
      invoiceCount
      firstInvoiceDate
      averageDaysToPayment
      doneInvoices {
        bankruptcy {
          invoiceCount
          amountsByCurrency {
            currencyCode
            totalAmount
          }
        }
        directPayment {
          invoiceCount
          amountsByCurrency {
            currencyCode
            totalAmount
          }
        }
        disputed {
          invoiceCount
          amountsByCurrency {
            currencyCode
            totalAmount
          }
        }
        internalMishandling {
          invoiceCount
          amountsByCurrency {
            currencyCode
            totalAmount
          }
        }
        overduePerAgreement {
          invoiceCount
          amountsByCurrency {
            currencyCode
            totalAmount
          }
        }
        paid {
          invoiceCount
          amountsByCurrency {
            currencyCode
            totalAmount
          }
        }
        recourseOther {
          invoiceCount
          amountsByCurrency {
            currencyCode
            totalAmount
          }
        }
      }
      openInvoices {
        debtCollection {
          invoiceCount
          amountsByCurrency {
            currencyCode
            totalAmount
          }
        }
        enforcementWarning {
          invoiceCount
          amountsByCurrency {
            currencyCode
            totalAmount
          }
        }
        open {
          invoiceCount
          amountsByCurrency {
            currencyCode
            totalAmount
          }
        }
        overdue {
          invoiceCount
          amountsByCurrency {
            currencyCode
            totalAmount
          }
        }
      }
    }
  }
`;

export default GET_CLIENT_RELATIONSHIP;
